import { makeStyles } from 'tss-react/mui';

export const useTabStyles = makeStyles()(theme => ({
  tabContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    maxWidth: theme.breakpoints.values.lg,
    padding: theme.spacing(3, 1),
    width: '75%',
  },
}));

export const useWorkflowDetailStyles = makeStyles()(theme => ({
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    height: '100%',
    width: '100%',
  },
  tabPanel: {
    alignItems: 'center',
    backgroundColor: theme.appColors.background,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'auto',
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // minHeight: 0 needed to make the flex item shrink smaller than its minContent size.
    minHeight: 0,
  },
}));
